import {
  BLACKJACK_IDS, BACCARAT_IDS, ROULETTE_IDS, CASINO_HOLDEM_ID, THREE_CARD_POKER_ID, BLACKJACK_UNLIMITED_ID,
} from '@ezugi/constants';

import { GAME_SLUGS } from '../../../constants/game';

// used only for POST Message
export const POSTMSG_GAMEID_TO_SLUG_MAP = {
  // BACCARAT
  2: GAME_SLUGS.BAC,
  // BACCARAT KO
  20: GAME_SLUGS.BAC,
  // BACCARAT SUPER SIX
  21: GAME_SLUGS.BAC,
  // BACCARAT MULTI SEAT
  22: GAME_SLUGS.BAC,
  // BACCARAT INSURANCE
  23: GAME_SLUGS.BAC,
  // BACCARAT DRAGON TIGER
  24: GAME_SLUGS.BAC,
  // BACCARAT NO COMMISSION
  25: GAME_SLUGS.BAC,
  // BACCARAT DRAGON BONUS
  26: GAME_SLUGS.BAC,
  // BACCARAT QUEENCO
  27: GAME_SLUGS.BAC,
  // BACCARAT PUNTO BANCO
  28: GAME_SLUGS.BAC,
  // BACCARAT CRICKET WAR
  45: GAME_SLUGS.BAC,
  // BLACKJACK
  1: GAME_SLUGS.BJ,
  // AMERICAN BLACKJACK
  10: GAME_SLUGS.BJ,
  // UNLIMITED BLACKJACK
  12: GAME_SLUGS.UBJ,
  // BLACKJACK SALON PRIVE
  46: GAME_SLUGS.BJ,
  // BLACKJACK VIDEO CHAT
  51: GAME_SLUGS.BJ,
  // ROULETTE
  3: GAME_SLUGS.ROU,
  // AUTOMATED ROULETTE
  7: GAME_SLUGS.ROU,
  // ROULETTE PORTOMASO
  29: GAME_SLUGS.ROU,
  // AMERICAN ROULETTE
  31: GAME_SLUGS.ROU,
  // AMERICAN AUTOMATED ROULETTE
  32: GAME_SLUGS.ROU,
  // AMERICAN OTT ROULETTE
  35: GAME_SLUGS.ROU,
  // RNG ROULETTE
  48: GAME_SLUGS.ROU,
  // ANDARBAHAR
  38: GAME_SLUGS.ANDAR,
  // OTT ANDARBAHAR
  39: GAME_SLUGS.ANDAR,
  // ULTIMATE ANDARBAHAR
  55: GAME_SLUGS.ANDAR,
  // THREE CARD POKER
  17: GAME_SLUGS.TCP,
  // CASINO HOLDEM
  15: GAME_SLUGS.CH,
  // LUCKY 7
  13: GAME_SLUGS.L7,
  // 32 CARDS
  19: GAME_SLUGS.TTC,
  // ONE DAY TEEN PATTI
  43: GAME_SLUGS.ODTP,
  // ONE DAY TEEN PATTI BACK AND LAY
  50: GAME_SLUGS.ODTP_BL,
  // RUSSIAN POKER
  53: GAME_SLUGS.RP,
  // ULTIMATE DICE
  54: GAME_SLUGS.UD,
};

const mapGameIds = (gameIds: number[], gameName: string) => gameIds.reduce(
  (acc, gameId) => ({ ...acc, [gameId]: gameName }),
  {}
);

export const BUNDLE_GAME_MAP = {
  ...mapGameIds(BLACKJACK_IDS, 'Blackjack'),
  ...mapGameIds(BACCARAT_IDS, 'Baccarat'),
  ...mapGameIds(ROULETTE_IDS, 'Roulette'),
  [CASINO_HOLDEM_ID]: 'CasinoHoldEm',
  [THREE_CARD_POKER_ID]: 'ThreeCardPoker',
  [BLACKJACK_UNLIMITED_ID]: 'UnlimitedBlackjack',
};
